import cn from "classnames";
import { useAppSelector } from "../../store/hooks";
import { selectActiveType } from "../../store/modelSlice";
import { IBlockInfoProps } from "./BlockInfo.props";
import styles from "./BlockInfo.module.scss";
import { forwardRef } from "react";

const BlockInfo = forwardRef<HTMLDivElement, IBlockInfoProps>(({ children, height, flexGrow, flexShrink, className, ...props }, ref): JSX.Element => {
	const activeType = useAppSelector(selectActiveType);

	return (
		<div
			className={cn(styles.blockInfo, {
				[styles.shadowFuture]: activeType === "future",
				[styles.shadowCurrent]: activeType === "current",
				[styles.shadowPrevious]: activeType === "previous",
				className,
			})}
			style={{ height, flexGrow, flexShrink }}
			ref={ref}
			{...props}
		>
			{children}
		</div>
	);
});

export default BlockInfo;
